import { ajax } from 'jquery';


// 為避免重複判斷，呼叫ajax時要有給complete或success cb時才會呼叫此函數
function statusCodeHandler({ xhr, status, result, cbSuccess, cbComplete }) {
	if (xhr.responseJSON) {
		switch (xhr.responseJSON.status) {
			case '405':
				return;
			// break;
			case '0':
			case '204':
			case '404':
				if (cbComplete) cbComplete(xhr, status);
				if (cbSuccess) cbSuccess(result, status, xhr);
				break;
			default:
		}
	}
}

export default function (obj) {
	const { complete, success, custId, ajaxsWip, ...others } = obj;

	if (ajaxsWip && custId) ajaxsWip.push(custId);

	if (custId) {
		others.beforeSend = xhr => {
			xhr.custId = custId;
		};
	}

	// 405代表session expired，則不執行給定的callback

	// 不論是否有給定complete函數，都要設定一個complete殼，
	// 執行ajax完成後從"未完成ajax"清單中除名的動作
	others.complete = (xhr, status) => {
		if (xhr.custId) {
			let ind = ajaxsWip.indexOf(xhr.custId);
			ajaxsWip.splice(ind, 1);
		}

		if (complete) {
			// 若有給定complete函數，則在非session expired情況下會被執行
			statusCodeHandler({
				xhr,
				status: status,
				cbComplete: complete
			});
		}
	}

	if (success) {
		others.success = (result, status, xhr) => {
			statusCodeHandler({
				xhr,
				status: status,
				result: result,
				cbSuccess: success
			});
		}
	}

	ajax(others);
};


// WEBPACK FOOTER //
// ./src/commonJS/custJqAjax.js